export const statusMap = {
  'Ready to submit': {
    color: 'success',
    icon: '#checked_2'
  },
  'Pending approval': {
    color: 'warning',
    icon: '#clock'
  },
  'Submission in progress': {
    color: 'success',
    icon: '#spinner_frame_1'
  },
  'Submission failed': {
    color: 'danger',
    icon: '#error'
  },
  'Ready for review': {
    color: 'info',
    icon: '#start'
  },
  'error': {
    color: 'danger',
    icon: '#error'
  },
  'Action required': {
    color: 'secondary',
    icon: '#start'
  },
  'Awaiting Imports': {
    color: 'primary',
    icon: '#download'
  },
  'Awaiting reconciliation': {
    color: 'primary',
    icon: '#scales'
  },
  'Submitted': {
    color: 'success',
    icon: '#checkmark'
  },
  'Outstanding': {
    color: 'info',
    icon: '#start'
  },
  'Complete': {
    color: 'success',
    icon: '#checkmark'
  },
  'In progress': {
    color: 'primary',
    icon: '#process'
  }
}
